function RampSignalList() {
    /// <summary>
    /// This object provides common functions for the Widget.Ramp.SignalList.vb <br/>
    /// It is a part of the ramp system. In future this visual should completely replace the old rampCharts!!<br/>
    /// Basically this visual has 2 parts - one is the tag-based tree menu and the second one is the signal list itself.<br/>
    /// Different tags can get assigned to each signal - the assigned tags are the base for the tree menu<br/>
    /// Author: ARF<br />
    /// Date: 5.1.2017<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 15.3.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.userOptions = new vcUserOptions();
    this.data = null;
    this.menuFilter = "";
    this.startDate = null;
    this.enddate = null;
    this.dateUserDef = false;
    this.interval = 1;
    this.usePrice = false;
    this.tagsLoaded = true; //get's set by an VCMQ event directly from the tag form.
    this.initialLoad = false;
    this.menuType = 0;
    this.dateDependendDetailsObj = null;
}
RampSignalList.prototype = new vcTemplate();

RampSignalList.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, radio buttons, datepickers and buttons.
    /// </summary>
   var me = this;
    try {


        if (me.error) { return false; }
        me.showInfo("", "", false);
       
        me.startDate = $.datepicker.parseDate('dd.mm.yy', getCurrentTimestamp());
        me.endDate = me.startDate;

        _VCMQ.produce(me.visual, me.vcgid, 'GET_RAMP_DATE_INIT', '');


        //init the 'add temperature signal' button
        me.visual.find(".vc-tree-menu-frame .button-toggle").off("click").on("click", function() {
            me.visual.find(".vc-tree-menu-frame .button-toggle").removeClass("button-toggle-active");
            me.menuType = parseInt($(this).data("type"));
            $(this).addClass("button-toggle-active");
            me.initMenu();
         
        }).button();



        //init the full-ext search
        me.visual.find("#tags-filter").vcFilter({ callback: function () { me.filterTags(); } });

        //init the main signal click handler
        me.visual.find("#div-entries").off("click", "#lst-signal li").on("click", "#lst-signal li", function () { me.selectItem($(this), false); });

        //init the click handlers for the different signal icons
        me.visual.find("#div-entries").off("click", ".popup").on("click", ".popup", function (e) { me.showDetails($(this)); e.stopPropagation(); });
        me.visual.find("#btn-close-details").off("click").on("click", function () { me.toggleDetails(false); }).button();

        //init the dbl click for an tag item - ifdbl clicked, the tag gets added to the vcFilter
        me.visual.find("#div-entries").off("dblclick", "#lst-signal li .col2 .vc-tags-item").on("dblclick", "#lst-signal li .col2 .vc-tags-item", function() {
            me.visual.find("#tags-filter").vcFilter("add", $(this).html());
        });
        //hover/click events for the edit icon of the tag list
        me.visual.find(".vc-list").on("mouseenter", ".col2", function () { $(this).append("<div data-type='TAGS' class='edit-icon'><i class='fa fa-pencil icon-color-info' ></i></div>"); });
        me.visual.find(".vc-list").on("mouseleave", ".col2", function() { $(this).children("div.edit-icon").remove(); });
        me.visual.find("#div-entries").off("click", ".edit-icon").on("click", ".edit-icon", function (e) { me.showDetails($(this)); e.stopPropagation(); });

        //init the archive rules button
        me.visual.find("#btn-add-rule").off("click").on("click", function () { me.openRuleEditor(-1, -1); }).button();
        me.visual.find("#div-entries").off("click", "#lst-signal .btn-edit-rule").on("click", ".btn-edit-rule", function (e) { me.editRule($(this)); e.stopPropagation(); });
        me.visual.find("#div-entries").off("click", "#lst-signal .btn-del-rule").on("click", ".btn-del-rule", function (e) { me.deleteRule($(this)); e.stopPropagation(); });

        //init the 'add temperature signal' button
        me.visual.find("#btn-add-temp").off("click").on("click", function () {me.toggleTempButton($(this)); }).button();

        //init the meta click handlers
        me.visual.find("#btn-show-meta-types").off("click").on("click", function () { me.toggleMetaTypes($(this)); });
        me.visual.find("#div-meta-types").off("click", "#lst-meta li").on("click", "#lst-meta li", function () { me.selectItem($(this), true); });
        me.visual.find("#chb-meta-selection").off("click").on("click", function () { me.selectAll("lst-meta", $(this), true); });

        //click handler for the 'select all' checkbox
        me.visual.find("#chb-signal-selection").off("click").on("click", function () { me.selectAll("lst-signal", $(this), false);});

        //filter all signals with the clicked tag
        me.visual.find("#div-entries").off("click", ".vc-tags-item").on("click", ".vc-tags-item", function(e) {
            var tag = $(this).find(".c").html();
            me.setMenuFilter(tag, false);
            e.stopPropagation();
        });



        //inits the button for the tag manager
        me.initTagManager();
     
       //adopt heights and widths  of list
        //me.visual.find("#div-entries,#div-entries .vc-list-table, #div-meta-types").height(parseInt(me.height - me.visual.find(".vc-tags").height() - me.visual.find("#signal-selection").height() - me.visual.find(".vc-list-header").height() + 20));
        me.visual.find("#div-entries,#div-entries .vc-list-table, #div-meta-types").height(parseInt(me.height - me.visual.find("#div-menu").outerHeight() ));


        me.visual.find("#div-meta-types .vc-list-table").height(me.visual.find("#div-meta-types").height() - 30);
        me.visual.find(".vc-list, #div-details,#div-details-content").width(parseInt(me.width - me.visual.find(".vc-tree-menu-frame").width() - 30));
        me.visual.find(" #div-details").height(parseInt(me.height, 10));
        me.visual.find(" #div-details-content").height(parseInt(me.height - me.visual.find("#div-details-menu").height()-5, 10));

       
        me.initUserOptions();

        return true;
    } catch (ex) {
        me.writeError('init', ex); return false; }
};

RampSignalList.prototype.initUserOptions = function () {
    /// <summary>
    /// This function fetches existing user options and prepares the initial settings.
    /// </summary>
    var me = this;
    try {

        me.userOptions.getUserOptions({ 'optgroupid': 'rampsignallist' }, function (result) {
            if (result == null) { me.fetchSignals(false); return true }
            if (result.rows === null) { alert(me.resources.errorOnLoad); return false; }
 
            for (var i = 0; i < result.rows.length; i++) {
                //add/remove the active toggle for the 'add-temp' button
                if (result.rows[i].optid === 1) {     
                    me.visual.find(".useroption[data-optid=" + result.rows[i].optid + "]").removeClass("button-toggle-active");
                    if (result.rows[i].bval) {
                        me.visual.find(".useroption[data-optid=" + result.rows[i].optid + "]").addClass("button-toggle-active");
                    }
                }
            }
            //get the signal list!!!
            me.fetchSignals(false);


            return true;
        });

    } catch (ex) {me.writeError('initUserOptions', ex); }

}

RampSignalList.prototype.selectItem = function (obj, setChb) {
    /// <summary>
    /// This function handles the select/unselect functionality for the signal and the meta types list <br/>
    /// the setChb parameter is only used to handle the checkbox in the meta type list
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (obj.hasClass("selected")) {
            obj.removeClass("selected");
            obj.find(".selection").html("<i class='fa fa-square icon-color-info'></i>");
            if (setChb) {obj.find("input").prop("checked", false);}
    } else {
            obj.addClass("selected");
            obj.find(".selection").html("<i class='fa fa-check-square icon-color-info'></i>");
            if (setChb) { obj.find("input").prop("checked", true);}
        }
        _VCMQ.produce(me.visual, me.vcgid, 'CHART_SERIES_CLEAR', '');
        return true;
    } catch (ex) { me.writeError('selectItem', ex); return false; }
};

RampSignalList.prototype.selectAll = function (lst, obj, setChb) {
    /// <summary>
    /// This function handles the select/unselect functionality for the signal and the meta types list <br/>
    /// the setChb parameter is only used to handle the checkbox in the meta type list
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (obj.is(":checked")) {
            me.visual.find("#" + lst + " li").addClass("selected");
            me.visual.find("#" + lst + " li .selection").html("<i class='fa fa-check-square icon-color-info'></i>");

            if (setChb) { me.visual.find("#" + lst + " li input").prop("checked", true); }
        } else {
            me.visual.find("#" + lst + " li").removeClass("selected");
            me.visual.find("#" + lst + " li .selection").html("<i class='fa fa-square icon-color-info'></i>");
            if (setChb) { me.visual.find("#" + lst + " li input").prop("checked", false); }
        }
        _VCMQ.produce(me.visual, me.vcgid, 'CHART_SERIES_CLEAR', '');
        return true;
    } catch (ex) { me.writeError('selectAll', ex); return false; }
};

RampSignalList.prototype.initMenu = function () {
    /// <summary>
    /// This function fetches all assigned tags for the given project and user and inits the vcTreeMenu <br/>
    /// 
    /// </summary>
    var me = this;
    try {
       
        if (me.error) { return false; }
        $('.vc-tree-menu').html("");

        //init list entry click handler
       
        window.VisualCoreService.getData(me.vcvid, '', getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 2, 'id': me.menuType }),
          function (result) {
              if (result == null) { me.visual.find('.vc-tree-menu').html(me.resources.err_loadData); return false; }
              if (result.rows === null) { me.visual.find('.vc-tree-menu').html("<div class='note'>" + me.resources.noEntriesExist + '</div>').show(); return false; }
              if (result.rows.length === 0) {
                  me.visual.find('.vc-tree-menu').html("<div class='note'>" + me.resources.noEntriesExist + '</div>')
                      .show();
                  me.sendRampEvent();
                  return false;
              }


             // console.info(result);
             // menuType = 0;
             // this.menuType = 1;
            
              $('.vc-tree-menu').html(me.vcC.getLoadingIcon());
             
              $('.vc-tree-menu').vcTreeMenu({
                     "h": me.height,
                  "data": result,
                  "clearFilter": true,
                     "showNotAssigned": me.menuType === 0, 
                     "callback": function (e) {
                          switch (e.type) {
                              case "init": // tree menu is ready to go

                                 
                                  me.setMenuFilter(e.value, false);
                                  me.sendRampEvent();
                                  me.tagsLoaded = true;
                                  break;
                              
                              case "update": // an item was selected in the tree menu
                              
                              me.toggleDetails(false);
                              me.setMenuFilter(e.value, true);
                              me.visual.find("#lst-signal li").addClass("selected");
                              me.visual.find("#lst-signal li .selection").html("<i class='fa fa-check-square icon-color-info'></i>");
                              //send rampMenu that we are ready to go!
                              me.sendRampEvent();
                              break;

                              case "error": //tree menu got an error
                                me.sendRampEvent();
                                me.writeError('initMenu.vcTreeMenu', e.value);
                              break;
                          default:
                          }
                      }
                  });
              
              return true;
          });

        return true;
    } catch (ex) { me.sendRampEvent(); me.writeError('initMenu', ex); return false; }
};

RampSignalList.prototype.fetchSignals = function (tagsLoaded) {
    /// <summary>
    /// This function fetches the signal list and generates the signal list. <br/>
    /// </summary>
    var me = this;
    try {

        if (me.error) { return false; }
        //save the currently selected items - we have to select them after loading again
        var currentlySelected = me.visual.find("#lst-signal li.selected.tagFound.menuFilterFound");




        //
        window.VisualCoreService.getData(me.vcvid, '', getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 1 }),
          function (result) {
              me.visual.find(".vc-list-table").hide();
              me.data = result;
             //build the list
              me.generateEntryList();

              me.addTickets();


              //filter the list with the current filter settings
              me.filterTags();
              //if everything was loaded - select all visible signals
              if (tagsLoaded) {
                  me.selectAll("lst-signal", me.visual.find("#chb-signal-selection"), true);
              } else {
                  //the tags have been changed ...
                  //so, we have to reload the tree menu and reset the selected signal items
                  me.initMenu();
                  currentlySelected.each(function() {
                      me.visual.find("#lst-signal #" + $(this).attr("id")).addClass("selected");
                      me.visual.find("#lst-signal #" + $(this).attr("id") + ' .selection').html("<i class='fa fa-check-square icon-color-info'></i>");
                  });


              }
              //send rampMenu that we are ready to go!
              me.tagsLoaded = true;
              _VCMQ.produce(me.visual, me.vcgid, 'EXPAND_RULES', '');

              //activate/deactive allowed signals for the current interval
             // me.handleAllowedIntervals();
              return true;
          });

      return true;
    } catch (ex) { me.writeError('fetchSignals', ex); return false; }
};

RampSignalList.prototype.generateEntryList = function () {
    /// <summary>
    /// This function builds a vc-list with the fetched signals - just html strings, nothing complicated  <br/>
    /// </summary>
    var me = this;
    var i;
    var sTmp = "";
    var row;
    try {
        if (me.error) { return false; }
        if (me.data === null) return false;

        me.visual.find(".vc-list").show();
        me.visual.find("#div-entries .vc-list-table").html(me.vcC.getLoadingIcon());
    
        if (me.data == null) { me.showMessage(me.resources.err_loadData, true); return false; }

        sTmp += "<ul id='lst-signal'>";
        if (me.data.rows !== null) {
            for (i = 0; i < me.data.rows.length; i++) {

                row = me.data.rows[i];
                sTmp += "<li id='bsaid" + row.id + "' data-id='" + row.id + "' data-interval='" + row.allowedinterval +
                    "' class='vc-list-item tagFound ";
                if (row.isarchiverule === false) {
                    sTmp += " isSignal ";
                } else {
                    sTmp += " isRule ";
                }

                sTmp += "'>";

                if (row.isarchiverule === false) {

                    sTmp += "<div class='vc-list-col vc-list-col-half'>";
                    sTmp += "<div class='vc-list-col-element col0";
                    if (row.bissum) {sTmp += " bissum";}
                    sTmp += "'>";
                    sTmp += "<div class='selection'></div>";
                    sTmp += "<i  class='vc-list-icon fa fa-eye-slash icon-color-error' title='" + me.resources.notAllowedInterval + "'></i>";

      
                    if (row.hr_resolution > 0) {
                        // sTmp += "<span class='fa - stack fa - 3x'><i class='fa fa - file - o fa - stack - 2x'></i><strong class='fa - stack - 1x fa - stack - text file - text'>" + row.hr_resolution +"</strong></span>";
                        sTmp += "<div class='hr-info color-font-secondary' title='" + me.resources.rawDataResolution + "'>" + (row.hr_resolution/60) + " min</div> ";

                    } else {
                        if (row.hr_based) {
                            sTmp += "<div class='hr-info color-font-secondary' title='" + me.resources.rawDataResolution + "'>15 min</div> ";
                        } else {
                            sTmp += "<div class='hr-info color-font-secondary'>-</div> ";

                        }
                    }
                   // sTmp += row.hr_based + " - " + row.hr_level + " - " + row.hr_resolution;


                    sTmp += row.name + " [" + row.dims + "]";
                    if (row.internal) {
                        sTmp += " " + me.resources.internal;
                    }
                    sTmp += "</div>";
                    sTmp += "<div class='vc-list-col-element col1'>";
                   

                    if (row.dataflow !== null) {
                        sTmp += "<i data-type='SANKEY' class='vc-list-icon popup fa fa-share-alt color-font-secondary' title='" + me.resources.dataflowDiagram + "'></i>";
                        sTmp += "<i data-type='SUBSIGNAL' class='vc-list-icon popup fa fa-chart-pie color-font-secondary' title='" + me.resources.subsignalDiagram + "'></i>";
                    }
                   

                    if (me.showTickets) {sTmp += "<i data-type='TICKET' class='vc-list-icon ticket popup fa-regular fa-ticket color-font-secondary'  title='" + me.resources.ticket + "'></i>";}

                    //if (row.alarm !== null) { sTmp += "<i data-type='ALARM' class='vc-list-icon popup fa-regular fa-bell color-font-secondary' title='" + me.resources.alarmPreview + "'></i>"; }
                    sTmp += "<i data-type='SIGNALINFO' class=' color-font-secondary vc-list-icon popup fa-regular fa-info-circle' title='" + me.resources.signalInfo + "'></i>";
                    sTmp += "</div>";
                    sTmp += "</div>";
                    sTmp += "<div class='vc-list-col vc-list-col-half'>";
                    // sTmp += "<div class='vc-list-col-element col2'>xx</div>";
                    sTmp += "<div data-type='TAGS' class='vc-list-col-element col2'>";

                   //add the tags
                    sTmp += me.vcC.expandTags(row.tags);
                    //add the equipment tags

                    //console.info(row.equiptags);
                    //sTmp += me.vcC.expandTags(row.equiptags);
                    sTmp += "</div>";
                    sTmp += "<div class='vc-list-col-element col3' ";
                    if (row.hardware !== null && row.protocol !== null && row.host !== null) {
                        sTmp += "data-blhid='" + row.blhid + "'>";

                        sTmp += row.protocol + "(" + row.hardware + ")@" + row.host + ":" + row.port + " <span>" + row.blhid + "</span>";
                    } else {
                        sTmp += ">";
                        if (row.issignalrule) {
                            sTmp += me.resources.virtual;
                        }
                    }

                    sTmp += "</div>";
                    sTmp += "</div>";

                } else {
                  
                    sTmp += "<div class='vc-list-col vc-list-col-half'>";               
                    sTmp += "<div class='vc-list-col-element col0'>";
                    sTmp += "<div class='selection'></div>";

                    sTmp += row.name + ' [';
                    if (row.dims.length === 0) {
                        sTmp += "-";
                    } else {
                        sTmp += row.dims;
                    }
                    
                    sTmp += ']<br/>';
                    
                    sTmp += "<div data-rule='" + row.rule + "' data-assid='" + row.rid_assid + "' data-rule_bsaid='" + row.rule_bsaid + "' data-rule_mtid='" + row.rule_mtid + "' class='archive-rule'><img src='../../images/visualcore/loading.gif' /></div>";
                    sTmp += "</div>";
                    sTmp += "<div class='vc-list-col-element col1'>";
                    if (row.rule_private || (row.rule_private === false && row.isadmin)) {
                        sTmp += "<i class='btn-edit-rule vc-list-icon fa fa-pencil color-font-secondary' title='" + me.resources.edit + "'></i>";
                        sTmp += "<i class='btn-del-rule vc-list-icon fa fa-times icon-color-error' title='" + me.resources.delete + "'></i>";
                    } else {
                        sTmp += "<i class='color-font-secondary vc-list-icon  fa fa-lock' title='" + me.resources.noEdit + "'></i>";
                    }
                    sTmp += "</div>";
                    sTmp += "</div>";
                    sTmp += "<div class='vc-list-col vc-list-col-half'>";
                    sTmp += "<div class='vc-list-col-element col2'>";
                    sTmp += me.vcC.expandTags(row.tags);
                    sTmp += "</div>";
                    sTmp += "</div>";
                }
                sTmp += "</li>";
            };
        }
        sTmp += "</ul>";
        me.visual.find("#div-entries .vc-list-table").html(sTmp);
        me.visual.find("#lst-signal .vc-list-item:odd").addClass("alt");

        return true;
    } catch (ex) { me.writeError('generateEntryList', ex); return false; }
};

RampSignalList.prototype.setMenuFilter = function (menuFilter, bSelectAll) {
    /// <summary>
    /// This function stores the received menu filter string from the tree menu.
    /// </summary>
    var me = this;
    try {
      
        me.menuFilter = menuFilter;
        //set as selected
        if (bSelectAll || me.initialLoad === false) {
            me.visual.find("#lst-signal li").removeClass("selected").addClass("selected");
            me.visual.find("#lst-signal li .selection").html("<i class='fa fa-check-square icon-color-info'></i>");
            me.visual.find("#chb-signal-selection").prop("checked", true);
            me.initialLoad = true;
        }

        //restart the filtering
       // if (me.menuType === 0) {
            me.filterTags();
        //}
        //if (me.menuType === 1) { me.filterHW(); }

    } catch (ex) { writeError('setMenuFilter', ex); }
};

RampSignalList.prototype.filterTags = function () {
    /// <summary>
    /// This function filters the tags based on a given menu filter and filters the complete content of the signal list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }


        //hide all
        me.visual.find("#lst-signal li.vc-list-item").removeClass("tagFound menuFilterFound").data("counter", 0).hide();

        //first we filter all signals with the tag we got from the vc-tree-menu
        if (me.menuFilter.length > 0) {

            if (me.menuFilter !== 'no_assigned_tags' && me.menuFilter !== 'has_ticket') {
                // me.visual.find('#lst-signal li.vc-list-item').filter(function () { return $(this).find(".col2 .vc-tags-item:contains('" + me.menuFilter + "')").length > 0 }).addClass("menuFilterFound");
                me.visual.find('#lst-signal li.vc-list-item').filter(function() {

                    var item = $(this);

                    if (me.menuType === 0) {
                        //see if we find a system tag
                        if ($(this).find(".col2 .vc-tags-item-system").html() === me.menuFilter) {
                            item.addClass("menuFilterFound");
                            return true;
                        }
                        var tags;
                        //split all tags and find the tag we are looking for
                        //why split the title? in the title we find the complete hierarchical tag eg: building / first floor / section 1
                        //if we won't search the title we would only find all 'section 1' tags but no 'building' or 'first floor'
                        $(this).find(".col2 .vc-tags-item").each(function () {
                            tags = $(this).attr("title").split(" / ");
                            for (var i = 0; i <= tags.length - 1; i++) {
                                if (tags[i] === me.menuFilter) {
                                    item.addClass("menuFilterFound");
                                    return true;
                                }
                            }
                            // ReSharper disable once NotAllPathsReturnValue
                        });
                    }
                    if (me.menuType === 1) {

                        //console.info(me.menuFilter);

                        var xcol = item.find(".col3");
                       
                        
                        if (xcol.length > 0) {

                            var col3 = xcol.html();
                            col3 = col3.replace("<span>", "").replace("</span>", "");
                            if (col3.indexOf(me.menuFilter) >= 0) {
                                item.addClass("menuFilterFound");
                                return true;
                            }
                        }
                        return false;
                    }
                    return false;
                });
            } else {
                if (me.menuFilter === 'no_assigned_tags' ) {
                //we have to find every signal which have no tags assigned (except the vc-tags-item-system which every item gets automatically)
                    me.visual.find('#lst-signal li.vc-list-item').filter(function() {
                        return $(this).find(".col2 .vc-tags-item").not(".vc-tags-item-system").length === 0;
                    }).addClass("menuFilterFound");
                }
                if (me.menuFilter === 'has_ticket') {
                    //we have to find every signal which have no tags assigned (except the vc-tags-item-system which every item gets automatically)
                    me.visual.find('#lst-signal li.vc-list-item').filter(function () {
                        return $(this).find(" .fa-ticket").css("opacity") === "1";
                    }).addClass("menuFilterFound");
                }
        

    }

        } else {
            //if no menu filter is set - take all entries
            me.visual.find("#lst-signal li.vc-list-item").addClass("menuFilterFound");
        }
        
        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", "#lst-signal li.vc-list-item", "tagFound");

        me.visual.find("#lst-signal li.vc-list-item.tagFound.menuFilterFound").show();
        
        //toggle the signal and meta list based on the allowed interval
        me.visual.find("#lst-signal li.vc-list-item").removeClass("notAllowedInterval").filter(function () { return $(this).data("interval") > me.interval }).addClass("notAllowedInterval").removeClass("tagFound");
        me.visual.find("#lst-meta li.vc-list-item").removeClass("notAllowedInterval").filter(function () { return $(this).data("interval") > me.interval }).addClass("notAllowedInterval");


        me.visual.find("#lst-signal li.vc-list-item").removeClass("alt");
        me.visual.find("#lst-signal li.vc-list-item.tagFound.menuFilterFound:even").addClass("alt");

        if (me.visual.find("#lst-signal li.vc-list-item.tagFound.menuFilterFound").length === 0 && me.visual.find("#lst-signal li.vc-list-item.notAllowedInterval").length === 0) {
            me.visual.find("#signal-selection, #div-entries .vc-list-table").hide();
            me.visual.find("#entry-info").html(me.resources.noEntriesExist).show();
            me.visual.find(".vc-list.signal-list").css("overflow-y", "hidden");

        } else {
            me.visual.find("#signal-selection #signal-counter").html(me.visual.find("#lst-signal li.vc-list-item.tagFound.menuFilterFound").length);
            me.visual.find("#signal-selection, #div-entries .vc-list-table").show();
            me.visual.find("#entry-info").hide();
            me.visual.find(".vc-list.signal-list").css("overflow-y", "auto");

        }

        me.visual.find(".vc-list-table").show();
        //now we are ready to go
        _VCMQ.produce(me.visual, me.vcgid, 'CHART_DIRTY', '');
        return true;
    } catch (ex) {
        me.writeError('filterTags', ex);
        return false;
    }

};

RampSignalList.prototype.initTagManager = function () {
    /// <summary>
    /// This function inits the button for the vcTagManager <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        me.visual.find("#btn-edit-tags").off("click").on("click", function () {
            me.tagsLoaded = false;
            me.toggleDetails(true);
            //set the data property that we remind us to reload the tree menu after closing the vcTagManager view
            me.visual.find("#btn-close-details").data("reloadOnClose", "1");
            me.visual.find("#div-details-content").vcTagManager({ 'ShowCalculations': true, h: parseInt(me.visual.find("#div-details-content").height(), 10),w: parseInt(me.visual.find("#div-details-content").width(), 10) });
        }).button();
        return true;
    } catch (ex) { me.writeError('initTagManager', ex); return false; }
};

RampSignalList.prototype.toggleDetails = function (bShow) {
    /// <summary>
    /// This function hides/shows the details div <br/>
    /// </summary>
    var me = this;
    try {

        if (bShow) {
            me.visual.find("#btn-close-details").data("reloadOnClose", 0);
            me.visual.find(".vc-list").hide();
            me.visual.find("#div-details-content").html(me.vcC.getLoadingIcon());
            me.visual.find("#div-details").show(500);
        } else {
            me.visual.find("#div-details-content").html("");
            me.visual.find("#div-details").hide();
            me.visual.find(".vc-list").show();
            //when we want to close the details we have a look if we have to reload the signal list (and the tree menu)
            if (me.visual.find("#btn-close-details").data("reloadOnClose") === "1") { me.fetchSignals(me.tagsLoaded); }
            me.dateDependendDetailsObj = null;
        }
        return true;
    } catch (ex) { me.writeError('toggleTempButton', ex); return false; }
};

RampSignalList.prototype.showDetails = function (obj) {
    /// <summary>
    /// This function does the handling of different sub/detail views <br/>
    /// </summary>
    var me = this;
    var bsaid;
    var isRule;
    var type;
    var param;
    var signalParam = { 'series': [] };
    try {
        if (me.error) { return false; }

        if (obj !== null) {
            bsaid = parseInt(obj.parents("li").data("id"), 10);
            // ReSharper disable once UnknownCssClass
            isRule = obj.parents("li").hasClass("isRule");
            type = obj.data("type");
        }
        me.toggleDetails(true);

        //we generate a random sub container every time 
        var container = me.getRandomIDContainerObj("div-details-", true);
        me.visual.find("#div-details-content").html(container.obj);

        me.dateDependendDetailsObj = null;
       
        switch (type) {
            case "HR":

              //  param = { interval: 10, startDate: moment(me.startDate).format("DD.MM.YYYY"), endDate: moment(me.endDate).format("DD.MM.YYYY"), dateUserDef: true, HighResolutionQualityLevel: -1 };
                param = { interval: 10, startDate: me.startDate, endDate: me.endDate, dateUserDef: true, HighResolutionQualityLevel: -1 };

                signalParam.series.push({ 'bsaid': [bsaid] });

           // console.info(param);
            me.vcVisual.addVisualBaseByName('div-details-', "VISUAL_CHART_HR_ONLINE", container.random, getCurrentTimestamp(), parseInt(me.visual.find("#div-details-content").height(), 10), parseInt(me.visual.find("#div-details-content").width(), 10), JSON.stringify(param), JSON.stringify(signalParam), me.deviceType);
            me.dateDependendDetailsObj = obj;
            break;
        case "SANKEY":
                param = { interval: me.interval, datatype: 2, startDate: me.startDate, endDate: me.endDate, usePrices: me.usePrice, dateUserDef: me.dateUserDef , HideLegend:true };
                _VCMQ.produce(me.visual, "-1", 'GET_EXPORT_URL_SETTINGS', {
                    'info': { bsaid: bsaid, name: '', description: '', startDate: me.startDate, endDate: me.endDate, dateUserDef: me.dateUserDef, interval: me.interval },
                    'visualname': "VISUAL_SIGNAL_SANKEY",
                    'parameter': JSON.stringify({ "hideLegend": true }),
                    'signalparameter': JSON.stringify({ "signalID": bsaid, "archiveParam": param })
                });

                me.vcVisual.addVisualBaseByName('div-details-', "VISUAL_SIGNAL_SANKEY", container.random, getCurrentTimestamp(), parseInt(me.visual.find("#div-details-content").height(), 10), parseInt(me.visual.find("#div-details-content").width(), 10), "", JSON.stringify({ "signalID": bsaid, "archiveParam": param }), me.deviceType);
                me.dateDependendDetailsObj = obj;
                break;
            case "SUBSIGNAL":



                param = { loggerID: me.blid, interval: me.interval, datatype: 2, startDate: me.startDate, endDate: me.endDate, usePrices: me.usePrice, dateUserDef: true, 'isArchive': true };
                _VCMQ.produce(me.visual, "-1", 'GET_EXPORT_URL_SETTINGS', {
                    'info': {bsaid:bsaid, name: '', description: '', startDate: me.startDate, endDate: me.endDate, dateUserDef: true, interval: me.interval },
                    'visualname': "VC_CHART_SUBSIGNALS",
                    'parameter': JSON.stringify(param),
                    'signalparameter': JSON.stringify({ "signalID": bsaid })
                });
                me.vcVisual.addVisualBaseByName('div-details-', "VC_CHART_SUBSIGNALS", container.random, getCurrentTimestamp(), parseInt(me.visual.find("#div-details-content").height(), 10), parseInt(me.visual.find("#div-details-content").width(), 10), JSON.stringify(param), JSON.stringify({ "signalID": bsaid }), me.deviceType);
                me.dateDependendDetailsObj = obj;
                break;
          

            case "SIGNALINFO":
                _VCMQ.produce(me.visual, "-1", 'GET_EXPORT_URL_SETTINGS', {
                    'info': { bsaid: bsaid, name: '', description: '' },
                    'visualname': "VISUAL_SIGNALANALOG_SUMMARY",
                    'parameter': "",
                    'signalparameter': JSON.stringify({ 'bsaid': bsaid })
                });
               

                me.vcVisual.addVisualBaseByName('div-details-', "VISUAL_SIGNALANALOG_SUMMARY", container.random, me.startDate, parseInt(me.visual.find("#div-details-content").height(), 10), parseInt(me.visual.find("#div-details-content").width(), 10), "", JSON.stringify({ 'bsaid': bsaid }), me.deviceType);
                break;
            case "ALARM":
                me.vcVisual.addVisualBaseByName('div-details-', "VISUAL_SIGNALANALOG_ALARMSUMMARY", container.random, getCurrentTimestamp(), parseInt(me.visual.find("#div-details-content").height(), 10), parseInt(me.visual.find("#div-details-content").width(), 10), "", JSON.stringify({ 'bsaid': bsaid }), me.deviceType);
                break;
            case "TICKET":
               
                _VCMQ.produce(me.visual, "-1", 'GET_EXPORT_URL_SETTINGS', {
                    'info': { bsaid: -2, name: '', description: '' },
                    'visualname': "VISUAL2_TICKET_LIST",
                    'parameter': JSON.stringify({ "ReadOnlyMode": true, 'SignalID': -1, 'LoggerID':me.blid }),
                    'signalparameter': ""
                });
                container.obj.height(parseInt(me.visual.find("#div-details-content").height(), 10));
                container.obj.width(parseInt(me.visual.find("#div-details-content").width(), 10));
               
                container.obj.TicketList({ invokeType: "addVisualBase", parameter: { "ReadOnlyMode": true, 'SignalID': bsaid, 'LoggerID': me.blid  }, deviceType: me.deviceType });
                 break;

            case "TAGS":
                me.tagsLoaded = false;

                // //yes - it's a hack, we negate the bsaid - so we know, that it is an archive rule 
                if (isRule) { bsaid = bsaid * -1; }
                me.visual.find("#btn-close-details").data("reloadOnClose", "1");
                me.vcVisual.addVisualBaseByName("div-details-", 'VISUAL_TAGS_ASSIGNMENT_TAGS2SIGNAL', container.random, getCurrentTimestamp(), parseInt(me.visual.find("#div-details-content").height(), 10), parseInt(me.visual.find("#div-details-content").width(), 10), JSON.stringify({ "assid": bsaid }), "", me.deviceType);
                break;
            default:
        }

        return true;
    } catch (ex) { me.writeError('showDetails', ex); return false; }
};


RampSignalList.prototype.addTickets = function () {
    /// <summary>
    /// This function shows/hides the ticket icons based on user rights and currently open tickets <br/>
    /// </summary>
    var me = this;
  
    try {
        if (me.error) { return false; }

        //here we show all ticket icons we found a ticket for
        me.tickets.forEach(function(e) {
            me.visual.find("#lst-signal #bsaid" + e + " .ticket").css("opacity", 1);
        });
        
        return true;
    } catch (ex) { me.writeError('addTickets', ex); return false; }
};

RampSignalList.prototype.expandRules = function() {
    /// <summary>
    /// This function is used to optionally load the complete archive rules.<br/>
    /// It generates a list of rule ids and sends it to the server<br/>
    /// The server generates the complete html for the rule and sends it back<br/>
    /// Then, we can fill the rule information with the rule html
    /// </summary>
    var me = this;
    var lst = [];
    var rid;
    var assid;
    try {
       
        //get a list of all rule ids
        me.visual.find('.archive-rule').each(function () {
            rid = parseInt($(this).parents("li").data('id'), 10);
            assid = parseInt($(this).data('assid'), 10);
            $(this).addClass("ruleid" + rid );
            lst.push({ 'rid': rid, 'assid': assid });
        });
        
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 3, 'rules': lst }),
             function (result) {
                 if (result === null) {     
                     obj.html("<div class='error'>" + me.resources.err_loadData + "</div>");
                 } else {
                     //now - fill the rules with the html
                     for (var i = 0; i <= result.length - 1; i++) {
                         me.visual.find(".ruleid" + result[i].Rid  ).html(result[i].Rule);
                     }
                 }
             });

    } catch (ex) { writeError('expandRules', ex);}
};

RampSignalList.prototype.editRule = function (obj) {
    /// <summary>
    /// This function handles the click handler for the rule editings
    /// </summary>
    var me = this;
    try {
        var assid = parseInt(obj.parents("li").find(".archive-rule").data("assid"), 10);
        var rid = parseInt(obj.parents("li").data("id"),10);
        me.openRuleEditor(rid, assid);
    } catch (ex) { writeError('editRule', ex); }
};

RampSignalList.prototype.openRuleEditor = function (rid, assid) {
    /// <summary>
    /// Guess ...
    /// </summary>
    var me = this;
    try {

        me.tagsLoaded = false;

        me.toggleDetails(true);
        me.visual.find("#btn-close-details").data("reloadOnClose", "1");
        me.vcVisual.addVisualContentByName('div-details-', "VISUAL_RAMP_SIGNALLIST_RULES", "content", getCurrentTimestamp(), parseInt(me.visual.find("#div-details-content").height(), 10), parseInt(me.visual.find("#div-details-content").width(), 10), JSON.stringify({ 'vcid': assid, 'rid': rid, 'showEntry': true }), '', me.deviceType);


    } catch (ex) { writeError('openRuleEditor', ex); }
};

RampSignalList.prototype.deleteRule = function (obj) {
    /// <summary>
    /// This function opens a modal dialog for deleting a single archive rule.<br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        var dialog = $('<p>' + me.resources.shouldDataGetDeleted + '</p>').dialog({
            title: me.resources.dialogTitle, modal: true,
            buttons: {
                "Yes": function () {
                    var rid = parseInt(obj.parents("li").data("id"), 10);
                    window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 1, 'id': rid }),
                        function (result) {
                            if (result.length === 0) {
                                alert(me.resources.err_delete);
                            } else {
                                //reload the signal list
                                me.fetchSignals(false);
                            }

                        });
                    dialog.dialog('close');

                },
                "Cancel": function () { dialog.dialog('close'); return false; }
            },
            dialogClass: 'saveDialog'
        });
        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(NO)').text(me.resources.no);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue
        return false;
    } catch (ex) { me.writeError('delBillDialog', ex); return false; }
};

RampSignalList.prototype.toggleTempButton = function (obj) {
    /// <summary>
    /// This function toggles the temperature button and stores the current state as user option <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (obj.hasClass("button-toggle-active")) {
            obj.removeClass("button-toggle-active");
            me.userOptions.setUserOptions({ 'optgroupid': 'rampsignallist', 'optid': 1, 'bval': false }, function () { });
        } else {
            obj.addClass("button-toggle-active");
            me.userOptions.setUserOptions({ 'optgroupid': 'rampsignallist', 'optid': 1, 'bval': true }, function () { });
        }
        return true;
    } catch (ex) { me.writeError('toggleTempButton', ex); return false; }
};

RampSignalList.prototype.toggleMetaTypes = function (obj) {
    /// <summary>
    /// This function ... <br/>
    /// </summary>
    var me = this;
    var w;
    try {
        if (me.error) { return false; }

        if (obj.hasClass("button-toggle-active")) {
            obj.removeClass("button-toggle-active");
            w = me.visual.find(".vc-list").width();
            me.visual.find("#div-entries").removeClass("show-meta").width(w);    
            me.visual.find("#div-meta-types li").removeClass("selected");
            me.visual.find("#div-meta-types").hide();
        } else {
            obj.addClass("button-toggle-active");
            w = me.visual.find(".vc-list").width() - me.visual.find("#div-meta-types").width() - 20;
            me.visual.find("#div-entries").addClass("show-meta").width(w);          
            me.visual.find("#div-meta-types").show();
            me.fetchMetaTypes();
        }
        return true;
    } catch (ex) { me.writeError('toggleMetaTypes', ex); return false; }
};

RampSignalList.prototype.fetchMetaTypes = function () {
    /// <summary>
    /// This function fetches all available meta types and generates the meta type list <br/>
    /// </summary>
    var me = this;
    try {

        if (me.error) { return false; }

        if ($('#div-meta-types .vc-list-table').html().length > 0) { return true;}

        $('#div-meta-types  .vc-list-table').html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, '', getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 4 }),
          function (result) {

              if (result == null) { me.visual.find('#div-meta-types').html(me.resources.err_loadData); return false; }
              if (result.rows === null) { me.visual.find('#div-meta-types').html("<div class='note'>" + me.resources.noEntriesExist + "</div>"); return false; }
              if (result.rows.length === 0) { me.visual.find('#div-meta-types').html("<div class='note'>" + me.resources.noEntriesExist + "</div>"); return false; }
              return me.generateMetaList(result);
          });

        return true;
    } catch (ex) { me.sendRampEvent(); me.writeError('fetchMetaTypes', ex); return false; }
};

RampSignalList.prototype.generateMetaList = function (meta) {
    /// <summary>
    /// This function iterates the meta type list and generates a html list with group headers <br/>
    /// </summary>
    var me = this;
    var row;
    var sTmp = "";
    var mtaaid = -1;
    var first = true;
    try {
        if (me.error) { return false; }

        if (meta.rows.length === 0) {return false}
     
        for (var i = 0; i < meta.rows.length; i++) {
            if (mtaaid !== meta.rows[i].mtaaid) {
                if (first===false) {
                    sTmp += "</ul>";
                }
                sTmp += "<div class='vc-list-header color-bg-secondary'><div class='vc-list-item'>" + meta.rows[i].area + "</div></div>";
                mtaaid = meta.rows[i].mtaaid;
                sTmp += "<ul id='lst-meta'>";
                first = false;
            } 
            row = meta.rows[i];
            sTmp += "<li data-id='" + row.mtid + "' data-ismeta='" + row.ismeta + "' data-interval='" + row.allowedinterval + "' class='vc-list-item' >";
            sTmp += "<input id='chb-meta'  type='checkbox' /> ";
            sTmp += "<i  class='vc-list-icon fa fa-eye-slash icon-color-error' title='" + me.resources.notAllowedInterval + "'></i>";
            sTmp += "" + row.name;
            sTmp += "</li>";
 
        }
        if (first ===false) { sTmp += "</ul>"; }

        $('#div-meta-types  .vc-list-table').html(sTmp);

        me.visual.find("#lst-meta .vc-list-item:odd").addClass("alt");

        me.filterTags();
        return true;

    } catch (ex) { me.sendRampEvent(); me.writeError('generateMetaList', ex); return false; }
};

RampSignalList.prototype.sendRampEvent = function () {
    /// <summary>
    /// This function sends an event to the ramp menu - to inform that the signal list is ready to go
    /// </summary>
    var me = this;
    try {
       
        if (me.sendRampInitEvent) {
            _VCMQ.produce(me.visual, me.vcgid, 'CHART_SIGNALLIST_INIT', '');
            me.sendRampInitEvent = false;
        }
    } catch (ex) { writeError('sendRampEvent', ex); }
};

RampSignalList.prototype.doEvent = function (event) {
    /// <summary>
    /// Handles the mq-events
    /// </summary>
    var me = this;
    try {

        switch (event.msg) {
            case "RAMP_DATE_INIT":
             
                //we receive this event from the ramp menu - so we can set the date intervals
                me.startDate = event.values.startDate;
                me.endDate = event.values.endDate;
                me.interval = event.values.interval;
                me.usePrice = event.values.usePrice;
                me.dateUserDef = event.values.dateUserDef;
            break;

            case "RAMP_DATE_CHANGED":
                //we receive this event from the ramp menu - so we can reset the date intervals
                //these settings we use for the detail charts like sankey and subsignal
                me.startDate = event.values.startDate;
                me.endDate = event.values.endDate;
                me.interval = event.values.interval;
                me.usePrice = event.values.usePrice;
                me.dateUserDef = event.values.dateUserDef;
              
                me.filterTags();
                if (me.dateDependendDetailsObj != null) {
                    me.showDetails(me.dateDependendDetailsObj);
                }
                break;
            case 'TAGS_REFRESH':
                //we receive from the vcTagManager and tag assignment
                //now, we have to reload the tree menu and the signal list
                me.tagsLoaded = false;
                break;
            case 'RULE_CLOSE':
               //the archive rule form has been closed/saved
                me.visual.find("#div-edit-rules").hide();
                me.visual.find(".vc-list, .vc-tree-menu").show();
                me.toggleDetails(false);
                me.fetchSignals(false);
                break;

            case 'INIT_MENU':
                //go, go, go
                me.initMenu();
                break;

            case "EXPAND_RULES":
                //let's waite a bit and then complete the rules
                //this is used for speed optimization when loading the complete page
                //first, everything else should load and finally the rule information
                setTimeout(me.expandRules(),1000);
                break;
            case "SHOW_HR":
                if (event.values) {
                    me.visual.find(".hr-info").css("display", "inline-block");
                } else {
                    me.visual.find(".hr-info").hide();
                }
          
                break;

            default: break;
        }
    } catch (ex) { writeError('doEvent', ex); }
};

RampSignalList.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
             me.visual.find('.vc-tree-menu,.vc-list,.vc-list-table,.vc-tags, .vc-list-header').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


